"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePostMessage = exports.sendBookingData = exports.sendReferralData = exports.requestPatient = void 0;
const constants_1 = require("../common/constants");
const util_1 = require("../common/util");
const requestPatient = ({ postMessageUrl, retries }) => (send) => __awaiter(void 0, void 0, void 0, function* () {
    if (retries.requestPatient === 0) {
        const initializeMachine = (e) => {
            if (e.data.status ===
                constants_1.CrmConnectorPostMessageEvents.CRM_CONFIRM_RECEIVE_PATIENT) {
                if (e.origin === postMessageUrl) {
                    sendPatientData(e);
                }
                else {
                    sendUnknownOrigin(e);
                }
            }
        };
        const sendUnknownOrigin = (e) => {
            send({
                type: constants_1.CrmConnectorEvents.UNKNOWN_ORIGIN,
                data: e
            });
        };
        const sendPatientData = (e) => {
            if (e.data.data) {
                send({
                    type: constants_1.CrmConnectorEvents.PATIENT_RECEIVED,
                    data: e.data.data
                });
                window.removeEventListener('message', initializeMachine);
            }
        };
        window.addEventListener('message', initializeMachine);
    }
    //Ask for Patient
    window.parent.postMessage({
        status: constants_1.CrmConnectorPostMessageEvents.CRM_INIT
    }, postMessageUrl);
    return null;
});
exports.requestPatient = requestPatient;
const sendReferralData = ({ id, referrals, postMessageUrl, patient }, ev) => {
    if (ev.type === constants_1.CrmConnectorEvents.SEND_REFERRAL_DATA) {
        try {
            const parsedReferrals = referrals.map(({ provider, location, status }) => ({
                provider: (0, util_1.parseCrmProvider)(provider),
                location,
                status
            }));
            window.parent.postMessage({
                status: constants_1.CrmConnectorPostMessageEvents.CRM_SAVE,
                data: Object.assign(Object.assign(Object.assign({}, (id == null ? {} : { id })), ((patient === null || patient === void 0 ? void 0 : patient.id) == null ? {} : { patient: patient.id })), { referrals: parsedReferrals, searchSummary: (0, util_1.parseSearchSummary)(ev.data.searchSummary) })
            }, postMessageUrl);
        }
        catch (e) {
            return e instanceof Error
                ? Promise.reject(e.message)
                : Promise.reject('Undefined Error');
        }
    }
    return Promise.resolve(true);
};
exports.sendReferralData = sendReferralData;
const sendBookingData = ({ id, postMessageUrl, patient }, ev) => {
    if (ev.type === constants_1.CrmConnectorEvents.SEND_BOOKING_DATA) {
        try {
            window.parent.postMessage({
                status: constants_1.CrmConnectorPostMessageEvents.CRM_SAVE,
                data: Object.assign(Object.assign(Object.assign({}, (id == null ? {} : { id })), ((patient === null || patient === void 0 ? void 0 : patient.id) == null ? {} : { patient: patient.id })), { booking: (0, util_1.formatAppointmentForCrm)(ev.data), searchSummary: (0, util_1.parseSearchSummary)(ev.data.searchSummary) })
            }, postMessageUrl);
        }
        catch (e) {
            return e instanceof Error
                ? Promise.reject(e.message)
                : Promise.reject('Undefined Error');
        }
    }
    return Promise.resolve(true);
};
exports.sendBookingData = sendBookingData;
const convertURLsToOrigins = (urls) => {
    if (!urls)
        return [];
    return (Array.isArray(urls) ? urls : urls.split(',')).reduce((accum, url) => {
        try {
            return [...accum, new URL(url).origin];
        }
        catch (e) {
            return accum;
        }
    }, []);
};
const validatePostMessage = ({ postMessageUrl }) => {
    var _a, _b;
    if (((_a = postMessageUrl === null || postMessageUrl === void 0 ? void 0 : postMessageUrl.length) !== null && _a !== void 0 ? _a : 0) === 0) {
        return Promise.reject(`postMessageUrl is not defined`);
    }
    try {
        const postMessageUrlArray = convertURLsToOrigins(postMessageUrl);
        const documentReferrer = (_b = convertURLsToOrigins(window.document.referrer)) === null || _b === void 0 ? void 0 : _b[0];
        if (postMessageUrlArray.length > 1 && documentReferrer) {
            if (postMessageUrlArray.includes(documentReferrer)) {
                return Promise.resolve(documentReferrer);
            }
            else {
                return Promise.reject(`window origin (${documentReferrer}) not found in configured values for postMessageUrl: ${postMessageUrlArray.join(', ')}`);
            }
        }
        else {
            return Promise.resolve(postMessageUrlArray[0]);
        }
    }
    catch (e) {
        return Promise.reject(`'${postMessageUrl}' is not a valid postMessageUrl, ${e}`);
    }
};
exports.validatePostMessage = validatePostMessage;
//# sourceMappingURL=services.js.map